import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideRefreshCw } from '@ng-icons/lucide';

import { UI } from '../../components/ui';
import {
  ProviderBalanceOverviewRow,
  ProviderBalanceService,
} from '../../services/provider-balance.service';
import { ShellRoutesService } from '../../services/shell-routes.service';
import { formatHumanAmount } from '../../utils/admin-formatting';

@Component({
  selector: 'app-provider-balances-page',
  standalone: true,
  imports: [CommonModule, RouterLink, NgIcon, ...UI],
  providers: [provideIcons({ lucideRefreshCw })],
  templateUrl: './provider-balances-page.component.html',
})
export class ProviderBalancesPageComponent implements OnInit {
  private readonly providerBalances = inject(ProviderBalanceService);
  readonly shellRoutes = inject(ShellRoutesService);

  readonly loading = signal(true);
  readonly error = signal<string | null>(null);
  readonly rows = signal<ProviderBalanceOverviewRow[]>([]);

  ngOnInit(): void {
    this.reload();
  }

  reload(): void {
    this.loading.set(true);
    this.error.set(null);
    this.providerBalances.listOverview().subscribe({
      next: (data) => {
        this.rows.set(data);
        this.loading.set(false);
      },
      error: (err) => {
        this.error.set(err?.error?.detail || 'Failed to load provider balances');
        this.loading.set(false);
      },
    });
  }

  formatAmount(value: string | null | undefined, currencyCode: string | null): string {
    if (value == null || value === '') return '—';
    return formatHumanAmount(value, currencyCode || '');
  }

  hubLink(row: ProviderBalanceOverviewRow): (string | number | boolean)[] {
    return this.shellRoutes.commands('manage', 'provider-balances', row.api_provider.id, 'hub');
  }

  hubQueryParams(row: ProviderBalanceOverviewRow): { currency?: string } {
    return row.currency_code ? { currency: row.currency_code } : {};
  }
}
